<template>
  
  <div>

    <transition name="fade-up" mode="out-in">
      <v-container v-if="loading" key="settings_loader">
        <v-layout>
          <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
        </v-layout> 
      </v-container>
      <v-container v-else grid-list-lg fluid key="settings_content">

        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12>
                <h3>Fit Profile</h3>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="field-label">*Height</div>
                <div class="field-label" style="opacity: .5">Feet</div>
                <v-select
                  v-model="fitData.height_ft"
                  :items="fit_options.height.feet"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="field-label">&nbsp;</div>
                <div class="field-label" style="opacity: .5">Inches</div>
                <v-select
                  v-model="fitData.height_in"
                  :items="fit_options.height.inches"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs6 sm3>
                <div class="field-label">*Top Size</div>
                <v-select
                  v-model="fitData.top_size"
                  :items="fit_options.top_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <div class="field-label">*Dress Size</div>
                <v-select
                  v-model="fitData.dress_size"
                  :items="fit_options.dress_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <div class="field-label">*Jean Size</div>
                <v-select
                  v-model="fitData.denim_waist_size"
                  :items="fit_options.jean_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <div class="field-label">*Pant Size</div>
                <v-select
                  v-model="fitData.pant_size"
                  :items="fit_options.pant_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <div class="field-label">*Bra Size</div>
                <v-select
                  v-model="fitData.bra_size"
                  :items="fit_options.bra_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs6 sm3>
                <div class="field-label">*Bra Cup</div>
                <v-select
                  v-model="fitData.bra_cup_size"
                  :items="fit_options.cup_sizes"
                  solo
                  flat
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <div class="field-label">*Body Shape</div>
                <v-layout row>
                  <v-flex
                    v-for="(shape, shapeIndex) in fit_options.body_shapes"
                    :key="'bodyshape-' + shapeIndex"
                    class="box-container pa-1 fitshape-container"
                  >
                    <v-hover>
                      <div 
                        slot-scope="{ hover }"
                        class="box-subcontainer pa-2"
                        :class="{'hovering':hover, 'selected':(fitData.body_shape == shape.key)}"
                        @click="fitData.body_shape = shape.key"
                      >
                        <div 
                          class="img-container" 
                          :style="{backgroundImage: 'url(' + cdn + shape.image + ')'}"
                        >
                        </div>
                        <div class="label-container font-weight-bold py-2">{{ shape.label }}</div>
                      </div> 
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 class="text-xs-center my-5">
                <v-btn color="primary" @click="updateFitProfile()" :loading="fitDataSaving">UPDATE</v-btn>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>


        <v-layout row justify-center>
          <v-flex style="max-width: 650px;">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12>
                <h3>Style Profile</h3>
              </v-flex>
              <v-flex xs12 my-4>
                <div class="field-label">*How would you describe your personal style</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(cstyle, cstyleIndex) in style_options.current_style"
                    :key="'cs-' + cstyleIndex"
                  >
                    <v-checkbox
                      v-model="styleData.current_style"
                      :label="cstyle.label"
                      :value="cstyle.key"
                      color="primary"
                      hide-details
                      multiple
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*Which colors do you prefer <i><u>not</u></i> to wear?</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(color, colorIndex) in style_options.colors_avoid"
                    :key="'color_avoid-' + colorIndex"
                    
                    class="color-container"
                  >
                    <v-checkbox
                      v-model="styleData.colors_avoid"
                      :label="color.key.substr(0,1).toUpperCase() + color.key.substr(1)"
                      :value="color.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*Which patterns do you prefer <i><u>not</u></i> to wear?</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(pattern, patternIndex) in style_options.patterns_avoid"
                    :key="'paterns_avoid-' + patternIndex"
                  >
                    <v-checkbox
                      v-model="styleData.patterns_avoid"
                      :label="pattern.label"
                      :value="pattern.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*My preferred necklines include...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(neckline, necklineIndex) in style_options.necklines"
                    :key="'necklines-' + necklineIndex"
                  >
                    <v-checkbox
                      v-model="styleData.necklines"
                      :label="neckline.label"
                      :value="neckline.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*I like my tops to fit...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(top, topIndex) in style_options.top_half_fit"
                    :key="'top-' + topIndex"
                  >
                    <v-checkbox
                      v-model="styleData.top_half_fit"
                      :label="top.label"
                      :value="top.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*My shirt-sleeve preference is...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(sleeve, sleeveIndex) in style_options.sleeve_preference"
                    :key="'top-' + sleeveIndex"
                  >
                    <v-checkbox
                      v-model="styleData.sleeve_preference"
                      :label="sleeve.label"
                      :value="sleeve.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*I feel comfortable in these dress styles...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(dress, dressIndex) in style_options.dress_style"
                    :key="'dress-' + dressIndex"
                  >
                    <v-checkbox
                      v-model="styleData.dress_style"
                      :label="dress.label"
                      :value="dress.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*I like my bottoms to fit...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(pant, pantIndex) in style_options.pant_fit"
                    :key="'pant-' + pantIndex"
                  >
                    <v-checkbox
                      v-model="styleData.pant_fit"
                      :label="pant.label"
                      :value="pant.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*You'll never see me wearing...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(avoid, avoidIndex) in style_options.items_avoid"
                    :key="'avoid-' + avoidIndex"
                  >
                    <v-checkbox
                      v-model="styleData.items_avoid"
                      :label="avoid.label"
                      :value="avoid.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 my-4>
                <div class="field-label">*I wish to conceal my...</div>
                <v-layout row wrap>
                  <v-flex
                    v-for="(conceal, concealIndex) in style_options.areas_conceal"
                    :key="'pant-' + concealIndex"
                    mt-1
                  >
                    <v-checkbox
                      v-model="styleData.areas_conceal"
                      :label="conceal.label"
                      :value="conceal.key"
                      color="primary"
                      multiple
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>


              <v-flex xs12 class="text-xs-center my-4">
                <v-btn color="primary" @click="updateStyleProfile()" :loading="styleDataSaving">UPDATE</v-btn>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        
      </v-container>
    </transition>

  </div>

</template>

<script>

import styleFields from '@/consts/styleFields';
import styleOptions from '@/consts/styleOptions';
import fitFields from '@/consts/fitFields';
import fitOptions from '@/consts/fitOptions';


export default {
  name: 'AccountProfileFitAndStyle',
  data () {
    return {
      
      loading: true,

      styleData: {},
      styleDataSaving: false,

      fitData: {},
      fitDataSaving: false,

      style_options: styleOptions,
      fit_options: fitOptions,

    }
  },
  mounted: function() {
    this.setDefaults('style');
    this.setDefaults('fit');

    let ref = this;
    setTimeout(() => {
      ref.loading = false;
    },300);
  },
  watch: {
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    fit: function() {
      return this.$store.getters.fit;
    },
    style: function() {
      return this.$store.getters.style;
    }
  },
  methods: {
    setDefaults: function(type) {
      if(type == 'fit') {
        this.fitData = {
          height_in: this.fit.height_in,
          height_ft: this.fit.height_ft,
          top_size: this.fit.top_size,
          dress_size: this.fit.dress_size,
          denim_waist_size: this.fit.denim_waist_size,
          pant_size: this.fit.pant_size,
          bra_size: this.fit.bra_size,
          bra_cup_size: this.fit.bra_cup_size,
          body_shape: this.fit.body_shape
        }
      }
      if(type == 'style') {
        this.styleData = {
          current_style: (this.style.current_style || []),
          colors_avoid: (this.style.colors_avoid || []),
          patterns_avoid: (this.style.patterns_avoid || []),
          necklines: (this.style.necklines || []),
          top_half_fit: (this.style.top_half_fit || []),
          sleeve_preference: (this.style.sleeve_preference || []),
          dress_style: (this.style.dress_style || []),
          pant_fit: (this.style.pant_fit || []),
          items_avoid: (this.style.items_avoid || []),
          areas_conceal: (this.style.areas_conceal || []),

        }
      }
    },

    updateFitProfile: function() {
      let data = JSON.parse(JSON.stringify(this.fitData));
      let keys = JSON.parse(JSON.stringify(Object.keys(data)));
      /*for(let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if(data[key] == null) delete data[key];
      }*/

      this.fitDataSaving = true;
      this.$http.post('users/' + this.user.id + '/fit', data)
        .then(response => {
          this.$store.commit('setFit', response.data);
          this.$toast.fire('Fit Settings Updated');
        })
        .catch(error => {
          console.log(error);
          this.$swal.fire({
            title: 'Error',
            text: 'There was a problem updating your profile. Please try again.'
          })
        })
        .finally(() => {
          this.fitDataSaving = false;
        });
    },
    
    updateStyleProfile: function() {
      let data = JSON.parse(JSON.stringify(this.styleData));

      for(let i = 0; i < Object.keys( styleFields ).length; i++) {
        let key = Object.keys( styleFields )[i];

        //Need to update any set to 'no_preference' with all options instead
        if(data[key].indexOf('no_preference') >= 0) {
          let arr = [];
          for(let i2 = 0; i2 < this.style_options[key].length; i2++) {
            if(this.style_options[key][i2].key != 'no_preference') arr.push(this.style_options[key][i2].key);
          }
          data[key] = arr;
        }

        //Need to update any set to 'none' to no options instead
        if(data[key].indexOf('none') >= 0) {
          data[key] = ['none'];
        }
      }
      

      this.styleDataSaving = true;
      this.$http.post('users/' + this.user.id + '/style', data)
        .then(response => {
          this.$store.commit('setStyle', response.data);
          this.$toast.fire('Style Settings Updated');
        })
        .catch(error => {
          console.log(error);
          this.$swal.fire({
            title: 'Error',
            text: 'There was a problem updating your profile. Please try again.'
          })
        })
        .finally(() => {
          this.styleDataSaving = false;
        });
    },
  }
}
</script>
